"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Plus = _interopRequireDefault(require("@honeybook/icons/dist/icons/Plus16"));
var _Minus = _interopRequireDefault(require("@honeybook/icons/dist/icons/Minus16"));
var _HBAccordion = require("./HBAccordion.styles");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var HBAccordionSummary = function HBAccordionSummary(_ref) {
  var id = _ref.id,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    children = _ref.children,
    toggle = _ref.toggle,
    _ref$isExpanded = _ref.isExpanded,
    isExpanded = _ref$isExpanded === void 0 ? false : _ref$isExpanded,
    collapseIcon = _ref.collapseIcon,
    expandedIcon = _ref.expandedIcon;
  var handleClick = function handleClick() {
    return toggle(isExpanded ? '' : id);
  };
  var renderIcon = function renderIcon() {
    if (isExpanded) {
      return collapseIcon || /*#__PURE__*/_react["default"].createElement(_Minus["default"], {
        color: _colors["default"].neutral800
      });
    }
    return expandedIcon || /*#__PURE__*/_react["default"].createElement(_Plus["default"], {
      color: _colors["default"].neutral800
    });
  };
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'accordion-summary',
    componentName: 'HBAccordionSummary'
  });
  return /*#__PURE__*/_react["default"].createElement(_HBAccordion.SummaryContainer, {
    id: id,
    onClick: handleClick,
    testId: finalTestId
  }, /*#__PURE__*/_react["default"].createElement(_HBAccordion.SummaryContent, null, children), /*#__PURE__*/_react["default"].createElement(_HBAccordion.IconContainer, null, renderIcon()));
};
var _default = exports["default"] = HBAccordionSummary;
//# sourceMappingURL=HBAccordionSummary.js.map